import { DestroyRef, inject, Injectable } from '@angular/core';
import { UdlControlledVocabulary } from '../../shared/models/udl-controlled-vocabulary.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UdlControlledVocabularyService } from './udl-controlled-vocabulary.service';

@Injectable({
  providedIn: 'root'
})

export class UdlModelService {
    /// Service to hold the current model, model version, model pk, and model name
    public models: UdlControlledVocabulary[] = [];

    // selected model
    public model?: UdlControlledVocabulary;
    public modelVersion: number = 0;
    public modelPk: number = 0;
    public modelName: string = "EPA UDL Overlap";
    private controlledVocabularyService: UdlControlledVocabularyService = inject(UdlControlledVocabularyService)
    private destroyRef = inject(DestroyRef)
    
    constructor() {
        this.initalizeModel();
    }

    private async initalizeModel() {
        this.controlledVocabularyService.getControlledVocabularyItemsByKey("Model").pipe(takeUntilDestroyed(this.destroyRef)).subscribe((items: UdlControlledVocabulary[]) => {
            this.models = items;
            this.modelVersion = Number(items[0].metadata ? JSON.parse(items[0].metadata).version : 0);
            this.model = items[0];
            this.modelPk = items[0].udl_controlled_vocabulary_pk;
        });
    }
}